import {Component, OnInit} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import {Driver, Taggable, Trailer, User} from 'shared';
import tagsIcon from '@iconify/icons-mdi/id-card';
import {DriverService} from '../../stores/driver.service';

@Component({
  selector: 'app-drivers-grid',
  templateUrl: './drivers-grid.component.html',
  styleUrls: ['./drivers-grid.component.scss']
})
export class DriversGridComponent implements OnInit {
  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canListTags: boolean;
  canDelete: boolean;

  phonePattern: any = /^\+\s*212\s*\d\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{2}$/;
  current: Driver;
  isNew = true;
  tagsIcon = tagsIcon;
  tagsPopupVisible: boolean;
  taggable: Taggable;

  constructor(
    private service: DriverService,
    private user: User,
  ) {
    // Data source
    this.ds = service.newDataSource();

    // Permissions
    this.canEdit = user.can('edit drivers');
    this.canAdd = user.can('add drivers');
    this.canDelete = user.can('delete drivers');
    this.canListTags = user.can('list tags');
  }

  ngOnInit(): void {
  }

  onEdit(e: any) {
    this.isNew = false;
    this.current = e.data;
  }

  onCreate() {
    this.isNew = true;
  }

  showTags(e: MouseEvent, data: Trailer) {
    e.preventDefault();
    this.taggable = data;
    this.tagsPopupVisible = true;
  }

}
